import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import SupportTicketsNavigator from "../../../navigation/SupportTicketsNavigator";
import styles from "./supportTicketsSection.module.css";

// تذاكر الدعم: the tickets inbox and the email delivery lookup ("I never got
// my code"), each tab with its own permission.
const SupportTicketsSection = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("support-tickets", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/support-tickets/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <SupportTicketsNavigator />
    </div>
  );
};

export default SupportTicketsSection;
